import { format } from 'owa-localize';

import type { PeopleSuggestion } from 'owa-search-service';
import {
    PARTICIPANT_QUERY_FORMAT_STRING,
    PARTICIPANT_DISPLAYNAME_QUERY_FORMAT_STRING,
    OR_SEPARATOR,
} from '../searchConstants';

export default function createPersonaSearchQueryString(
    personaSuggestion: PeopleSuggestion
): string {
    const singlePersonaQueries: string[] = [];

    // Adding a participants(DisplayName) query
    singlePersonaQueries.push(
        format(PARTICIPANT_DISPLAYNAME_QUERY_FORMAT_STRING, personaSuggestion.DisplayName)
    );

    // Adding a participants(email@address.com) query per email
    personaSuggestion.EmailAddresses.forEach(email => {
        singlePersonaQueries.push(format(PARTICIPANT_QUERY_FORMAT_STRING, email));
    });

    // Joining all the queries with an OR
    const singlePersonaQueryString = singlePersonaQueries.join(OR_SEPARATOR);
    return singlePersonaQueryString;
}
